<div class="legend-wrapper" *ngIf="showLegend">
	<div class="legend-title">{{ legendTitle }}</div>
	<div class="legend-container">
		<div class="legend-group" *ngFor="let group of legendGroups">
			<div class="legend-group-title">{{ group.title }}</div>

			<div class="legend-item" *ngFor="let item of group.items">
				<span
					class="legend-symbol"
					[ngClass]="[
						item.type || 'dot',
						item.severity || item.colorClass
					]"
				></span>
				<span class="legend-label">{{ item.label }}</span>
			</div>
		</div>

		<div class="legend-items-row" *ngIf="legend.length">
			<div class="legend-item" *ngFor="let item of legend">
				<span class="legend-symbol dot" [ngClass]="item.severity"></span>
				<span class="legend-label">
					{{ item.severity }} ({{ item.label }})
				</span>
			</div>
		</div>
	</div>
</div>